/**
 * Updates the document title with the given page name
 * Format: "Page Name | Synked" or just "Synked" for home page
 * @param {string} pageName - The name of the current page
 */
export const setPageTitle = (pageName) => {
  if (pageName) {
    document.title = `${pageName} | Synked`;
  } else {
    document.title = 'Synked';
  }
}; 